import { debounce, get } from "lodash";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LANG } from "~/constans/commom";
import {
  PositionStatus,
  useGetPositionsGuideLazyQuery,
} from "~/schemas/generated/graphql";

export const useGetPositionsForSelect = (status?: boolean) => {
  const { t } = useTranslation();
  const isEn = localStorage.getItem("language") === LANG.en;

  const [getPositionQuery, { data, loading, fetchMore }] =
    useGetPositionsGuideLazyQuery({
      variables: {
        page: 0,
        count: 25,
        status: status ? PositionStatus.Active : undefined,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    getPositionQuery();
  }, []);

  const positions = useMemo(
    () =>
      get(data, "PositionGetter.getPositions.items", []).map(
        ({ id, code, name }) => ({
          value: id,
          label: `${code}. ${name}`,
        }),
      ),
    [data],
  );

  const intersectionObserver = () => {
    if (positions.length < 25) {
      return;
    }
    const page = Math.ceil(positions.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ PositionGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { PositionGetter };
        }
        return {
          PositionGetter: {
            ...PositionGetter,
            getPositions: {
              ...PositionGetter.getPositions,
              items: [
                ...PositionGetter.getPositions.items,
                ...get(
                  fetchMoreResult,
                  "PositionGetter.getPositions.items",
                  [],
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getPositionQuery({
      variables: {
        page: 0,
        searchText: searchText,
      },
    });
  });

  return {
    positions,
    intersectionObserver,
    searchText,
    loading,
  };
};
